var _mask, _path, _path2, _mask2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRedCross = function SvgRedCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "red-cross_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.7 2.5a1 1 0 1 1 1.42-1.42l9.2 9.2a1 1 0 0 1-1.42 1.4L.7 2.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-grey3)",
    d: "M.7 2.5a1 1 0 1 1 1.42-1.42l9.2 9.2a1 1 0 0 1-1.42 1.4L.7 2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-red)",
    d: "m.7 2.5 9.2 9.19 2.83-2.83-9.2-9.2L.72 2.5Zm10.61 7.77-9.19-9.2L-.7 3.92l9.2 9.19 2.82-2.83Zm-1.41 0a1 1 0 0 1 1.41 0L8.5 13.1a3 3 0 0 0 4.24 0L9.9 10.27Zm0 1.42a1 1 0 0 1 0-1.42l2.83 2.83a3 3 0 0 0 0-4.24L9.9 11.69Zm-7.78-9.2a1 1 0 0 1-1.41 0L3.54-.34a3 3 0 0 0-4.25 0L2.12 2.5ZM-.7-.34a3 3 0 0 0 0 4.25l2.83-2.83a1 1 0 0 1 0 1.41L-.7-.34Z",
    mask: "url(#red-cross_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "red-cross_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.08 1.08a1 1 0 1 1 1.42 1.41l-9.2 9.2a1 1 0 0 1-1.4-1.43l9.2-9.2Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-grey3)",
    d: "M10.08 1.08a1 1 0 1 1 1.42 1.41l-9.2 9.2a1 1 0 0 1-1.4-1.43l9.2-9.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-red)",
    d: "M10.08 1.08.9 10.28l2.83 2.82 9.19-9.2-2.83-2.82ZM2.3 11.68l9.2-9.19L8.67-.34l-9.2 9.2 2.83 2.82Zm0-1.4a1 1 0 0 1 0 1.4L-.52 8.86a3 3 0 0 0 0 4.24l2.82-2.83Zm-1.41 0a1 1 0 0 1 1.41 0L-.52 13.1a3 3 0 0 0 4.24 0L.89 10.27Zm9.2-7.79a1 1 0 0 1 0-1.41L12.9 3.9a3 3 0 0 0 0-4.25L10.08 2.5ZM12.9-.34a3 3 0 0 0-4.24 0L11.5 2.5a1 1 0 0 1-1.42 0l2.83-2.83Z",
    mask: "url(#red-cross_svg__b)"
  })));
};
export default SvgRedCross;